import React from "react";

import { Link } from "gatsby";
import { graphql, useStaticQuery } from "gatsby";

import { Box, Typography } from "@mui/material";

const getData = graphql`
  query MenuLinks {
    allSite {
      nodes {
        siteMetadata {
          siteMenu {
            link
            name
          }
        }
      }
    }
  }
`;

const HeaderMenu = () => {
  const data = useStaticQuery(getData);
  const { siteMenu } = data.allSite.nodes[0].siteMetadata;
  return (
    <Box
      sx={{
        display: { xs: "flex", sm: "block" },
        flexDirection: { xs: "column" },
      }}
    >
      {siteMenu.map((item) => (
        <Box className="mui-btn" key={item.name}>
          <Link
            to={`${item.link}`}
            activeStyle={activeLinkStyle}
            style={linkStyle}
          >
            <Typography variant="body1">{item.name}</Typography>
          </Link>
        </Box>
      ))}
    </Box>
  );
};

export default HeaderMenu;

const linkStyle = { textDecoration: "none", color: "#FFFEBF" };
const activeLinkStyle = { color: "#89FBFF" };
